/**
 * MoveChallenge component exports
 */

import MoveChallenge from './MoveChallenge';
export type { MoveChallengeProps } from './MoveChallenge';

export default MoveChallenge; 